// Gusto 99 - Wishlist Engine
(function() {
  'use strict';

  const STORAGE_KEY = 'gusto_wishlist_items';

  const Wishlist = {
    // Get all items from localStorage
    getItems: function() {
      try {
        const stored = localStorage.getItem(STORAGE_KEY);
        return stored ? JSON.parse(stored) : [];
      } catch (e) {
        console.error('Error reading wishlist from localStorage', e);
        return [];
      }
    },

    // Save items to localStorage
    saveItems: function(items) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
        this.updateHeaderBadge();
        this.updateAllButtonStates();
        window.dispatchEvent(new CustomEvent('gusto:wishlist:updated', { detail: { items: items } }));
      } catch (e) {
        console.error('Error saving wishlist to localStorage', e);
      }
    },

    // Check if a product is in wishlist by handle/id
    hasItem: function(identifier) {
      if (!identifier) return false;
      const cleanId = String(identifier).trim().toLowerCase();
      const items = this.getItems();
      return items.some(item => String(item.id).trim().toLowerCase() === cleanId);
    },

    // Add item to wishlist
    addItem: function(productData) {
      if (!productData || !productData.id) return;
      const items = this.getItems();
      const cleanId = String(productData.id).trim().toLowerCase();
      
      const existsIndex = items.findIndex(item => String(item.id).trim().toLowerCase() === cleanId);
      if (existsIndex === -1) {
        items.push({
          id: cleanId,
          variantId: productData.variantId ? String(productData.variantId) : '',
          variantTitle: productData.variantTitle || productData.size || '',
          handle: productData.handle || '',
          title: productData.title || 'Gusto Product',
          price: productData.price || '₹1,046',
          mrp: productData.mrp || '',
          badge: productData.badge || '',
          image: productData.image || '',
          url: productData.url || '/collections/all',
          quantity: productData.quantity || 1
        });
        this.saveItems(items);
      }
    },

    // Update variant data for a wishlist item
    updateVariant: function(identifier, newVariantData) {
      if (!identifier || !newVariantData) return;
      const cleanId = String(identifier).trim().toLowerCase();
      const items = this.getItems();
      const index = items.findIndex(it => 
        String(it.id).trim().toLowerCase() === cleanId || 
        (it.variantId && String(it.variantId).trim().toLowerCase() === cleanId) ||
        (it.handle && String(it.handle).trim().toLowerCase() === cleanId)
      );
      if (index > -1) {
        if (newVariantData.id) items[index].id = String(newVariantData.id);
        if (newVariantData.variantId) items[index].variantId = String(newVariantData.variantId);
        if (newVariantData.variantTitle) items[index].variantTitle = newVariantData.variantTitle;
        if (newVariantData.price) items[index].price = newVariantData.price;
        if (newVariantData.mrp !== undefined) items[index].mrp = newVariantData.mrp;
        if (newVariantData.badge !== undefined) items[index].badge = newVariantData.badge;
        if (newVariantData.image) items[index].image = newVariantData.image;
        if (newVariantData.url) items[index].url = newVariantData.url;
        this.saveItems(items);
      }
    },

    // Remove item from wishlist
    removeItem: function(identifier) {
      if (!identifier) return;
      const cleanId = String(identifier).trim().toLowerCase();
      let items = this.getItems();
      items = items.filter(item => String(item.id).trim().toLowerCase() !== cleanId);
      this.saveItems(items);
    },

    // Toggle wishlist state
    toggleItem: function(productData) {
      if (!productData || !productData.id) return false;
      const cleanId = String(productData.id).trim().toLowerCase();
      if (this.hasItem(cleanId)) {
        this.removeItem(cleanId);
        return false;
      } else {
        this.addItem(productData);
        return true;
      }
    },

    // Update quantity of an item and sync with Cart if present
    updateQuantity: function(identifier, qty) {
      const cleanId = String(identifier).trim().toLowerCase();
      const items = this.getItems();
      const item = items.find(it => String(it.id).trim().toLowerCase() === cleanId);
      if (item) {
        const newQty = Math.max(1, parseInt(qty) || 1);
        item.quantity = newQty;
        this.saveItems(items);

        // If item already exists in cart, keep quantity in sync
        if (window.GustoCart && window.GustoCart.hasItem(cleanId)) {
          window.GustoCart.updateQuantity(cleanId, newQty);
        }
      }
    },

    // Update header wishlist badge count
    updateHeaderBadge: function() {
      const items = this.getItems();
      const count = items.length;
      
      const wishlistIcons = document.querySelectorAll('.header-icon-btn[aria-label="Wishlist"], a[href="/pages/wishlist"]');
      wishlistIcons.forEach(btn => {
        let badge = btn.querySelector('.wishlist-count-badge');
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'wishlist-count-badge';
          btn.appendChild(badge);
        }
        badge.textContent = count;
        badge.style.display = count > 0 ? 'flex' : 'none';
      });
    },

    // Update all heart button states across current page
    updateAllButtonStates: function() {
      const items = this.getItems();
      const wishlistedIds = new Set(items.map(item => String(item.id).trim().toLowerCase()));

      // 1. Product card wishlist buttons (.product-wishlist-btn)
      document.querySelectorAll('.product-wishlist-btn').forEach(btn => {
        const id = btn.getAttribute('data-wishlist-id');
        if (id && wishlistedIds.has(String(id).trim().toLowerCase())) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });

      // 2. Main Product Details wishlist toggle (.product-wishlist-toggle)
      document.querySelectorAll('.product-wishlist-toggle').forEach(btn => {
        const id = btn.getAttribute('data-wishlist-id');
        if (id && wishlistedIds.has(String(id).trim().toLowerCase())) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });
    },

    // Initialize wishlist listeners & buttons
    init: function() {
      const self = this;
      self.updateHeaderBadge();
      self.updateAllButtonStates();

      // Delegate click event for wishlist buttons
      document.addEventListener('click', function(e) {
        const btn = e.target.closest('.product-wishlist-btn, .product-wishlist-toggle');
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();

        const id = btn.getAttribute('data-wishlist-id');
        const title = btn.getAttribute('data-product-title') || 'Gusto Product';
        const price = btn.getAttribute('data-product-price') || '₹1,046';
        const mrp = btn.getAttribute('data-product-mrp') || '';
        const badge = btn.getAttribute('data-product-badge') || '';
        const image = btn.getAttribute('data-product-image') || '';
        const url = btn.getAttribute('data-product-url') || '/collections/all';

        if (!id) return;

        const isAdded = self.toggleItem({
          id: id,
          title: title,
          price: price,
          mrp: mrp,
          badge: badge,
          image: image,
          url: url
        });

        // Trigger pulse animation
        btn.classList.toggle('active', isAdded);
      });
    }
  };

  window.GustoWishlist = Wishlist;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => Wishlist.init());
  } else {
    Wishlist.init();
  }

  document.addEventListener('shopify:section:load', () => {
    Wishlist.updateHeaderBadge();
    Wishlist.updateAllButtonStates();
  });

  window.addEventListener('storage', function(e) {
    if (e.key === STORAGE_KEY) {
      Wishlist.updateHeaderBadge();
      Wishlist.updateAllButtonStates();
    }
  });

  window.addEventListener('pageshow', function() {
    Wishlist.updateHeaderBadge();
    Wishlist.updateAllButtonStates();
  });

  window.addEventListener('gusto:wishlist:updated', function() {
    Wishlist.updateHeaderBadge();
    Wishlist.updateAllButtonStates();
  });
})();
